import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'



declare var window:any

export type DefinirCodigoMotivoDesconto = {
    
}

export async function definirCodigoMotivoDesconto(codigoMotivoDesconto: number) {
    const orcamentoAtualizado = await microuniversoApi.Orcamento.DefinirCodigoMotivoDesconto(
        store.getState().orcamento.IdentificadorOrcamento,
        codigoMotivoDesconto
    )

    const atualizarEstado = () => {
        const orcamentoLegado = window.orcamentoController.model
        orcamentoLegado.atualizar(orcamentoAtualizado, true, true)
        store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))
    }


    atualizarEstado()
}